(function () {
  if (window.__CartShippingCalculatorBooted) return;
  window.__CartShippingCalculatorBooted = true;

  class CartShippingCalculator {
    constructor(instanceId) {
      this.instanceId = instanceId;
      this.init();
    }

    init() {
      this.bindEvents();
      this.setupInputMask();
      this.restoreZipcodeFromStorage();
    }

    bindEvents() {
      const calculateBtn = document.getElementById(`calculateShipping${this.instanceId}`);
      const zipcodeInput = document.getElementById(`zipcode${this.instanceId}`);

      if (calculateBtn && !calculateBtn.dataset.shippingCalcBound) {
        calculateBtn.dataset.shippingCalcBound = 'true';
        calculateBtn.addEventListener('click', () => this.calculateShipping());
      }

      if (zipcodeInput && !zipcodeInput.dataset.shippingCalcBound) {
        zipcodeInput.dataset.shippingCalcBound = 'true';

        zipcodeInput.addEventListener('keypress', (e) => {
          if (e.key === 'Enter') {
            this.calculateShipping();
          }
        });

        zipcodeInput.addEventListener('input', (e) => {
          this.formatZipcode(e.target);
        });
      }

      if (!window.__CartShippingCalculatorResizeBound) {
        window.__CartShippingCalculatorResizeBound = true;
        let resizeTimeout;
        window.addEventListener('resize', () => {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(() => {
            if (window.initCartShippingCalculators) {
              window.initCartShippingCalculators();
            }
          }, 250);
        });
      }
    }

    setupInputMask() {
      const zipcodeInput = document.getElementById(`zipcode${this.instanceId}`);
      if (zipcodeInput && !zipcodeInput.dataset.shippingCalcMask) {
        zipcodeInput.dataset.shippingCalcMask = 'true';
        zipcodeInput.addEventListener('input', (e) => {
          let value = e.target.value.replace(/\D/g, '');
          if (value.length > 5) {
            value = value.replace(/(\d{5})(\d)/, '$1-$2');
          }
          e.target.value = value;
        });
      }
    }

    formatZipcode(input) {
      let value = input.value.replace(/\D/g, '');
      if (value.length > 5) {
        value = value.replace(/(\d{5})(\d)/, '$1-$2');
      }
      input.value = value;
    }

    restoreZipcodeFromStorage() {
      const zipcodeInput = document.getElementById(`zipcode${this.instanceId}`);
      if (!zipcodeInput) return;

      const stored = window.localStorage.getItem('cep');
      if (!stored) return;

      zipcodeInput.value = stored;
      this.formatZipcode(zipcodeInput);
    }

    async calculateShipping() {
      const inputEl = document.getElementById(`zipcode${this.instanceId}`);
      if (!inputEl) return;

      const zipcode = inputEl.value.replace(/\D/g, '');

      if (!this.validateZipcode(zipcode)) {
        this.showError('Por favor, digite um CEP válido (8 dígitos)');
        return;
      }

      this.showLoading(true);
      this.hideError();
      this.hideResults();
      this.hideStreetName();

      try {
        const addressData = await this.fetchAddressData(zipcode);
        window.localStorage.setItem('cep', zipcode);

        if (addressData && addressData.logradouro) {
          this.showStreetName(addressData);
        }

        const shippingOptions = await this.fetchShippingRates(zipcode, addressData);

        if (shippingOptions && shippingOptions.length > 0) {
          this.showShippingOptions(shippingOptions);
        } else {
          this.showError('Nenhuma opção de frete disponível para este CEP.');
        }
      } catch (error) {
        console.error('Erro ao calcular frete:', error);

        try {
          const shippingOptions = await this.fetchShippingRates(zipcode, null);
          if (shippingOptions && shippingOptions.length > 0) {
            this.showShippingOptions(shippingOptions);
          } else {
            this.showError('Erro ao consultar CEP e calcular frete. Tente novamente.');
          }
        } catch (shippingError) {
          this.showError('Erro ao consultar CEP e calcular frete. Tente novamente.');
        }
      } finally {
        this.showLoading(false);
      }
    }

    async fetchAddressData(zipcode) {
      try {
        const response = await fetch(`https://viacep.com.br/ws/${zipcode}/json/`);
        const data = await response.json();

        if (data.erro) {
          throw new Error('CEP não encontrado');
        }

        return data;
      } catch (error) {
        throw new Error('Erro ao consultar CEP');
      }
    }

    getBrazilStatesMap() {
      return {
        AC: 'Acre',
        AL: 'Alagoas',
        AP: 'Amapá',
        AM: 'Amazonas',
        BA: 'Bahia',
        CE: 'Ceará',
        DF: 'Distrito Federal',
        ES: 'Espírito Santo',
        GO: 'Goiás',
        MA: 'Maranhão',
        MT: 'Mato Grosso',
        MS: 'Mato Grosso do Sul',
        MG: 'Minas Gerais',
        PA: 'Pará',
        PB: 'Paraíba',
        PR: 'Paraná',
        PE: 'Pernambuco',
        PI: 'Piauí',
        RJ: 'Rio de Janeiro',
        RN: 'Rio Grande do Norte',
        RS: 'Rio Grande do Sul',
        RO: 'Rondônia',
        RR: 'Roraima',
        SC: 'Santa Catarina',
        SP: 'São Paulo',
        SE: 'Sergipe',
        TO: 'Tocantins',
      };
    }

    async fetchShippingRates(zipcode, addressData) {
      const states = this.getBrazilStatesMap();

      const country = 'Brazil';
      const zip = zipcode;

      let province;
      let city;

      if (addressData && addressData.uf) {
        province = states[addressData.uf] || addressData.uf;
        city = addressData.localidade;
      }

      const data = await this.fetchShopifyShippingRates({
        country,
        province,
        city,
        zip
      });
      const shippingRates = Array.isArray(data?.shipping_rates) ? data.shipping_rates : [];
      return this.normalizeShopifyRates(shippingRates);
    }

    async fetchShopifyShippingRates({ country, province, city, zip }) {
      const shippingData = {
        'shipping_address[country]': country,
        'shipping_address[zip]': zip,
      };

      if (province) shippingData['shipping_address[province]'] = province;
      if (city) shippingData['shipping_address[city]'] = city;

      const response = await fetch(`/cart/shipping_rates.json?${new URLSearchParams(shippingData).toString()}`);
      if (!response.ok) {
        throw new Error('Erro ao buscar opções de frete');
      }
      return response.json();
    }

    normalizeShopifyRates(shippingRates) {
      return shippingRates
        .map((rate) => {
          const priceNumber = this.parseShopifyPrice(rate?.price);
          const timeText = this.formatDeliveryTime(rate);

          return {
            name: rate?.name || 'Opção de frete',
            price: priceNumber,
            time: timeText || 'Prazo não informado',
          };
        })
        .filter((rate) => typeof rate.price === 'number');
    }

    parseShopifyPrice(price) {
      if (typeof price === 'number') return price;
      if (typeof price !== 'string') return 0;

      const normalized = price.replace(',', '.');
      const num = Number(normalized);
      return Number.isFinite(num) ? num : 0;
    }

    formatDeliveryTime(rate) {
      const deliveryDays = rate?.delivery_days;

      if (Array.isArray(deliveryDays) && deliveryDays.length >= 2) {
        const min = deliveryDays[0];
        const max = deliveryDays[1];
        if (typeof min === 'number' && typeof max === 'number') {
          if (min === max) return `${min} dias úteis`;
          return `${min} a ${max} dias úteis`;
        }
      }

      const deliveryRange = rate?.delivery_range;
      if (Array.isArray(deliveryRange) && deliveryRange.length >= 2) {
        const min = deliveryRange[0];
        const max = deliveryRange[1];
        if (typeof min === 'number' && typeof max === 'number') {
          if (min === max) return `${min} dias úteis`;
          return `${min} a ${max} dias úteis`;
        }
      }

      return '';
    }

    validateZipcode(zipcode) {
      return zipcode && zipcode.length === 8 && /^\d{8}$/.test(zipcode);
    }

    showLoading(show) {
      const button = document.getElementById(`calculateShipping${this.instanceId}`);
      if (!button) return;

      const buttonText = button.querySelector('.shipping-calculator__button-text');
      const loading = button.querySelector('.shipping-calculator__loading');
      if (!buttonText || !loading) return;

      if (show) {
        button.disabled = true;
        buttonText.style.display = 'none';
        loading.style.display = 'flex';
      } else {
        button.disabled = false;
        buttonText.style.display = 'inline';
        loading.style.display = 'none';
      }
    }

    showError(message) {
      const errorDiv = document.getElementById(`errorMessage${this.instanceId}`);
      const errorText = document.getElementById(`errorText${this.instanceId}`);

      if (errorDiv && errorText) {
        errorText.textContent = message;
        errorDiv.style.display = 'flex';
      }
    }

    hideError() {
      const errorDiv = document.getElementById(`errorMessage${this.instanceId}`);
      if (errorDiv) {
        errorDiv.style.display = 'none';
      }
    }

    showStreetName(addressData) {
      const streetDiv = document.getElementById(`streetName${this.instanceId}`);
      const streetText = document.getElementById(`streetNameText${this.instanceId}`);

      if (streetDiv && streetText) {
        const fullAddress = `${addressData.logradouro}, ${addressData.bairro} - ${addressData.localidade}/${addressData.uf}`;
        streetText.textContent = fullAddress;
        streetDiv.classList.add('show');
      }
    }

    hideStreetName() {
      const streetDiv = document.getElementById(`streetName${this.instanceId}`);
      if (streetDiv) {
        streetDiv.classList.remove('show');
      }
    }

    showShippingOptions(options) {
      const resultsDiv = document.getElementById(`shippingResults${this.instanceId}`);
      const optionsDiv = document.getElementById(`shippingOptions${this.instanceId}`);

      if (!resultsDiv || !optionsDiv) {
        return;
      }

      optionsDiv.innerHTML = '';

      if (!options || options.length === 0) {
        return;
      }

      options.forEach((option, index) => {
        const optionElement = this.createShippingOptionElement(option, index);
        optionsDiv.appendChild(optionElement);
      });

      resultsDiv.style.display = 'block';
      this.checkScrollNeeded();
    }

    createShippingOptionElement(option, index) {
      const div = document.createElement('div');
      div.className = 'shipping-calculator__option';
      div.style.animationDelay = `${(index + 1) * 0.1}s`;

      const name = option.name || 'Opção de frete';
      const time = option.time || 'Prazo não informado';
      const price = typeof option.price === 'number' ? option.price : 0;

      const priceText = price === 0 ? 'Grátis' : `R$ ${price.toFixed(2).replace('.', ',')}`;
      const priceClass = price === 0 ? 'free' : '';

      let icon = '🚚';
      if (name.toLowerCase().includes('sedex')) {
        icon = '⚡';
      } else if (name.toLowerCase().includes('grátis') || price === 0) {
        icon = '🎁';
      } else if (name.toLowerCase().includes('pac')) {
        icon = '📦';
      }

      div.innerHTML = `\
      <div class="shipping-calculator__option-details">\
        <div class="shipping-calculator__option-name">${icon} ${name}</div>\
        <div class="shipping-calculator__option-time">${time}</div>\
      </div>\
      <div class="shipping-calculator__option-price ${priceClass}">${priceText}</div>\
    `;

      return div;
    }

    hideResults() {
      const resultsDiv = document.getElementById(`shippingResults${this.instanceId}`);
      if (resultsDiv) {
        resultsDiv.style.display = 'none';
      }
    }

    checkScrollNeeded() {
      const optionsDiv = document.getElementById(`shippingOptions${this.instanceId}`);
      if (!optionsDiv) return;

      if (window.innerWidth <= 768) {
        const hasScroll = optionsDiv.scrollHeight > optionsDiv.clientHeight;
        optionsDiv.classList.toggle('has-scroll', hasScroll);
      }
    }
  }

  function initAllInstances() {
    const calculators = document.querySelectorAll('.shipping-calculator[id^="shippingCalculator"]');
    calculators.forEach((calculator) => {
      if (calculator.dataset.initialized) return;

      const instanceId = calculator.id.replace(/^shippingCalculator/, '');
      const zipcode = document.getElementById(`zipcode${instanceId}`);
      const button = document.getElementById(`calculateShipping${instanceId}`);

      if (zipcode && button) {
        calculator.dataset.initialized = 'true';
        window.__CartShippingCalculatorInstances = window.__CartShippingCalculatorInstances || {};
        window.__CartShippingCalculatorInstances[instanceId] = new CartShippingCalculator(instanceId);
      }
    });
  }

  window.initCartShippingCalculators = initAllInstances;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllInstances);
  } else {
    initAllInstances();
  }

  const bindEventBus = () => {
    if (!window.eventBus || window.__CartShippingCalculatorEventBusBound) return;
    window.__CartShippingCalculatorEventBusBound = true;

    window.eventBus.on('update:cart:drawer', initAllInstances);
    window.eventBus.on('render:cart:drawer', initAllInstances);
    window.eventBus.on('drawer:opened', (drawerEl) => {
      if (drawerEl && drawerEl.tagName && drawerEl.tagName.toLowerCase() === 'cart-drawer') {
        initAllInstances();
      }
    });
  };

  bindEventBus();
  setTimeout(bindEventBus, 0);
})();
